import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  moreTo?: string;
  moreLabel?: string;
  action?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  moreTo,
  moreLabel = "查看全部",
  action,
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6 md:mb-8">
      <div>
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 text-xs font-label tracking-[0.2em] text-primary-600 uppercase mb-2">
            <span className="w-5 h-px bg-primary-400"></span>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">{title}</h2>
        {desc && <p className="mt-1.5 text-sm text-foreground-500 max-w-2xl">{desc}</p>}
      </div>
      {action ??
        (moreTo && (
          <Link
            to={moreTo}
            className="hidden sm:inline-flex items-center gap-1 text-sm font-label text-secondary-600 hover:text-accent-600 transition-colors cursor-pointer whitespace-nowrap shrink-0"
          >
            {moreLabel}
            <i className="ri-arrow-right-line"></i>
          </Link>
        ))}
    </div>
  );
}